import { FiAddressTypes } from '../../core/address-types';
import { ObjectTypes } from '@fi-shared/types';

export interface IAddressModel {
    Id: number;
    ObjectId: number;
    ObjectType: ObjectTypes;
    AddressType: FiAddressTypes;
    Street: string;
    StreetExtra: string;
    ZipCode: string;
    City: string;
    Country: string;
    IsDefault: boolean;
    FullAddressValue: string;
}

export class AddressModel implements IAddressModel {
    Id = 0;
    ObjectId = 0;
    ObjectType = 1;
    AddressType: FiAddressTypes = FiAddressTypes.HomeAddress;
    Street = '';
    StreetExtra = '';
    ZipCode = '';
    City = '';
    Country = '';
    IsDefault = false;
    FullAddressValue: string;

    constructor(data?: IAddressModel) {
        if (data) {
            this.Initialize(data);
        }
    }

    Initialize(address: IAddressModel) {
        Object.assign(this, address);
    }
}
